import api from '../api';

const routes = require('routes.js.erb');

const createSubscription = function({ commit }, params){
  return api.post(routes.api_v5_subscriptions_path(), params)
};

const getSubscription = function({ _commit }, { id, params }) {
  return api.get(routes.api_v5_subscription_path(id, params));
};

const teamTrialUpsell = function({ commit }, params){
  return api.post(routes.team_trial_upsell_api_v5_subscriptions_path(), params)
};

export { createSubscription, getSubscription, teamTrialUpsell };
